import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LocalStorageService } from '../../services/localstorage.service';
import { GenericService } from '../generic.services';
import { SportsService } from '../sport.service';
import { TranslationService } from '../translation.service';

@Injectable({
  providedIn: 'root',
})
export class TeamsFavoritesService {
  private urlAPI = environment.API;
  private urlGetTeamsBySearch = 'getAllTeamsBySearch';
  private urlGetTeamsBySearchApp = 'getAllTeamsBySearchApp';
  private urlGetCompetitionsBySearchApp = 'getAllCompetitionsBySearchApp';
  private teamById = 'getTeamByIdFutbol';
  private teamInfoById = 'getTeamInformationByIdFutbol';
  private teamLineUpById = 'getTeamLineupByIdFutbol';

  private http = inject(HttpClient);
  private env = environment;
  private headers = new HttpHeaders({
    accept: 'application/json',
    'Content-Type': 'application/json',
  });

  constructor(
    private readonly translatorService: TranslationService,
    private readonly lsService: LocalStorageService,
    public genericServices: GenericService,
    private sportsServices: SportsService
  ) {}

  private postFavoritesTeam(teamId: string, userId: string) {
    this.http.post(`${this.env.baseUrl}teams/favorite/`, {
      teamId,
      userId,
    });
  }

  private deleteFavoritesTeam(teamId: string, userId: string) {
    this.http.delete(`${this.env.baseUrl}teams/favorite/`, {
      headers: this.headers,
      body: {
        teamId: teamId,
        userId,
      },
    });
  }

  favoriteTeam(team: any): any {
    if (this.lsService.setFavoritesTeam(team)) {
      team.favorite = !team.favorite;
      return team;
    }
  }

  /***
   * Obtain all teams to search favorites
   */
  getTeamsBySearch(searchText: any): Observable<any> {
    return this.http.post<any>(
      `${this.urlAPI}${
        this.urlGetTeamsBySearch
      }/${this.translatorService.getCurrentLanguage()}`,
      {
        sport: this.sportsServices.sportSearchText(),
        favoriteTeams: this.lsService.getFavoriteFromLocal('TEAM'),
        searchText,
      }
    );
  }

  getTeamsBySearchApp(searchText: any): Observable<any> {
    return this.http.post<any>(
      `${this.urlAPI}${
        this.urlGetTeamsBySearchApp
      }/${this.translatorService.getCurrentLanguage()}`,
      {
        sport: this.sportsServices.sportSearchText(),
        favoriteTeams: this.lsService.getFavoriteFromLocal('TEAM'),
        searchText,
      }
    );
  }

  getCompetitionsBySearchApp(searchText: any): Observable<any> {
    return this.http.post<any>(
      `${this.urlAPI}${
        this.urlGetCompetitionsBySearchApp
      }/${this.translatorService.getCurrentLanguage()}`,
      {
        sport: this.sportsServices.sportSearchText(),
        favoriteCompetitions:
          this.lsService.getFavoriteFromLocal('COMPETITION'),
        searchText,
      }
    );
  }
  /***
   * Obtain info team by id
   */
  getTeamById(id: string): Observable<any> {
    return this.http.get<any>(
      `${this.urlAPI}${
        this.teamById
      }/${this.translatorService.getCurrentLanguage()}/${id}`
    );
  }

  /***
   * Obtain All info team by id
   */
  getTeamInfoById(id: string): Observable<any> {
    return this.http.get<any>(
      `${this.urlAPI}${
        this.teamInfoById
      }/${this.translatorService.getCurrentLanguage()}/${id}`
    );
  }

  /***
   * Obtain lineup team by id
   */
  getTeamLineUpById(id: string): Observable<any> {
    const date: any =
      Date.parse(
        this.genericServices.getCurrentDate().toString() + ' 00:00:01'
      ) / 1000;
    return this.http.get<any>(
      `${this.urlAPI}${
        this.teamLineUpById
      }/${this.translatorService.getCurrentLanguage()}/${id}/${date}`
    );
  }
}
